import { render, staticRenderFns } from "./myfhd.vue?vue&type=template&id=889ae432&scoped=true&"
import script from "./myfhd.vue?vue&type=script&lang=js&"
export * from "./myfhd.vue?vue&type=script&lang=js&"
import style0 from "./myfhd.vue?vue&type=style&index=0&id=889ae432&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889ae432",
  null
  
)

export default component.exports